
import { useMsal } from "@azure/msal-react";
import { fetchToken } from "../services/fetchTokenService";
import { loginRequest } from "../auth/authConfig";
import SessionValidation from "../context/SessionValidationContext";

export const useAddCollaboratorsInTeamsChatService  = () => {
  const { instance, accounts } = useMsal();
  const {setSessionExpired} = SessionValidation()
  const addCollaboratorsinTeamsChatNew  = async (collaborator,postmortemTeamsChatData) => {
 
   try {
      const tokenResponse = await fetchToken(instance, loginRequest, accounts);
      if(tokenResponse && tokenResponse.sessionExpired){
        sessionStorage.clear();
        setSessionExpired(true)
      }
      fetch(
        "https://graph.microsoft.com/v1.0/chats/" +
          postmortemTeamsChatData +
          "/members",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Add other headers if needed
            Authorization: `Bearer ${tokenResponse.accessToken}`,
          },
          body: JSON.stringify({
            chatType: "group",
            topic: "Group chat title",
            "@odata.type": "#microsoft.graph.aadUserConversationMember",
            "user@odata.bind":
              "https://graph.microsoft.com/v1.0/users/" + collaborator,
            visibleHistoryStartDateTime: "0001-01-01T00:00:00Z",
            roles: ["owner"],
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => console.log(data))
        .catch((error) => console.error("Error:", error));
  }
    catch (error) {
      console.error("Error:", error);
    }
  };
  return {
    addCollaboratorsinTeamsChatNew,
  };
};